import { useCallback, useEffect, useState } from "react";

import { restoreSession, signOut as cognitoSignOut } from "@/lib/auth";
import { type AppUser } from "@/lib/types";

export const useAuth = () => {
  const [user, setUser] = useState<AppUser | null>(null);
  // `checking` is true until we've asked Cognito whether a cached session exists. Gates the initial render so we
  // don't flash the login page on refresh while the stored session is still valid.
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void restoreSession().then((u) => {
      if (cancelled) return;
      setUser(u);
      setChecking(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const onSignedIn = useCallback((u: AppUser) => setUser(u), []);

  const logout = useCallback(() => {
    cognitoSignOut();
    setUser(null);
  }, []);

  return { user, checking, isAuthenticated: !!user, onSignedIn, logout };
};
